const text = [
    {
        title: `
            ### Ratings in HOLC residential safety map, 1937

            #### With New Haven city boundaries`,
        body: `
            ## Redlining in New Haven

            In 1937, the Home Owners' Loan Corporation (HOLC) mapped ratings of how "safe" it was to invest in homeownership in neighborhoods covering most of New Haven and parts of surrounding towns. Ratings went from A, "Best," to D, "Hazardous," based on the demographics and economic well-being of residents in each neighborhood.
        `
    }, {
        title: `
            ### Ratings in HOLC residential safety map, 1937

            #### With New Haven city and neighborhood boundaries`,
        body: `
            ## Same neighborhoods, 80 years later

            Today's neighborhoods are easily identifiable on this 80-year-old map: lower ratings were given to areas that are still home to Black and immigrant communities, and high ratings--and with them, mortgages--were given to areas that are still affluent and mostly white.
        `
    }, {
        title: '### Population by race, Greater New Haven, 2016',
        body: `
            ## Our towns are still segregated today

New Haven is a racially diverse city, but the surrounding towns, aside from Hamden and West Haven, are nearly 90 percent white. Hamden and West Haven stand out from the other suburbs by being more diverse than the more affluent suburbs and having more opportunities for lower- and middle-income families to buy houses.
        `
    }, {
        title: '### Homeownership rate by HOLC grade, 2010',
        body: `
            ## Homeownership is still connected to grade

Homeownership remains elusive in redlined areas. Today, homeownership is more than twice as high in grade A blocks than in the grade D blocks that were seen as unfit for investment generations ago.
        `
    }, {
        title: `### Share of housing units that are single-family, 2016`,
        body: `
			## You can't buy houses where they don't exist

One issue here is the housing stock. Only a quarter of New Haven's housing units are single-family houses, whereas single-family housing is the norm in the suburbs. Most of the suburbs have zoning laws that restrict or forbid building multi-family housing, keeping out families that need to rent.
		`
    }, {
        title: '### Homeownership rate, Greater New Haven, 2016',
        body: `
            ## Few city residents own their homes

It's typical for homeownership to be lower in cities than in surrounding suburbs. Homeownership is nearly 3 times as high in the suburbs, excluding Hamden and West Haven, as it is in the city.
        `
    }, {
        title: '### Homeownership rate by race, Greater New Haven, 2016',
        body: `
            ## But it's not just about location

Regardless of where they live, Black and Latino families have much lower homeownership rates. Even in suburbs with high homeownership rates, Black and Latino families are much less likely to own than their white neighbors.
        `
    }, {
        title: '### Share of homeowners by race and HOLC grade, 2010',
        body: `
            ## Segregation in where we live and what we own

Generations after grade A neighborhoods were marked for investment, the beneficiaries of this investment are still almost all white. White people make up 88 percent of the homeowners in grade A neighborhoods today. And while homeownership is low in grade C and D areas, white residents of those areas make up disproportionately large shares of the owners.
        `

    }, {
        title: `### Share of residents living in racially-isolated census tracts, Greater New Haven, 2016

        #### Racially-isolated tracts are those where at least 75 percent of residents are of a single race
        `,
        body: `
            ## White residents are isolated within the region

Another way to measure segregation is how isolated groups are from one another. Nearly three-quarters of the white residents of Greater New Haven live in a neighborhood that is at least 75 percent the same race as them. Only 7 percent of Black residents live in such an isolated area, and no areas are so overwhelmingly Latino.
        `
    }, {
        title: `### Share of residents living in racially-isolated census tracts, Greater New Haven, 1980-2016

        #### Racially-isolated tracts are those where at least 75 percent of residents are of a single race
        `,
        body: `
            ## Some good news

As isolated as we are, this is actually an improvement: in 1980, nearly 90 percent of white residents and over a quarter of Black ones lived in racially-isolated neighborhoods.

We have a long way to go towards integrating our area. But while our segregated landscape today looks bad, it's at least less bad than a few decades ago.
        `
    },
];

export default text;



// WEBPACK FOOTER //
// ./src/data/text.js